import { createContext } from 'react';

export interface PdfViewerOptions {
  url: string;
  title: string;
  subtitle?: string;
}

export interface PdfViewerContextType {
  isOpen: boolean;
  options: PdfViewerOptions | null;
  openPdf: (options: PdfViewerOptions) => void;
  closePdf: () => void;
}

export const PdfViewerContext = createContext<PdfViewerContextType | undefined>(undefined);
